export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  cover: string;
  category: string;
  categoryId: string;
  author: string;
  status: '连载中' | '已完结';
  description: string;
  rating: number;
  views: number;
  chapters: ComicChapter[];
  updateDate: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line' },
  { id: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { id: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { id: 'action', name: '动作', icon: 'ri-fire-line' },
  { id: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { id: 'comedy', name: '喜剧', icon: 'ri-emotion-laugh-line' },
  { id: 'drama', name: '剧情', icon: 'ri-book-open-line' },
  { id: 'horror', name: '惊悚', icon: 'ri-ghost-line' },
  { id: 'daily', name: '日常', icon: 'ri-sun-line' },
];

export const comics: Comic[] = [
  {
    id: '1',
    title: '恶女的救赎',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20webtoon%20cover%20art%20style%20featuring%20an%20elegant%20female%20protagonist%20with%20flowing%20dark%20hair%20in%20a%20vintage%20royal%20dress%2C%20dramatic%20lighting%2C%20soft%20watercolor%20background%20with%20golden%20accents%2C%20romance%20fantasy%20genre&width=400&height=560&seq=comic-01&orientation=portrait',
    category: '恋爱',
    categoryId: 'romance',
    author: '李智恩',
    status: '连载中',
    description: '重生回到过去，这一次她不会再做任人宰割的羔羊。面对曾经伤害过她的人，她选择用智慧和勇气改写命运。但那个冷酷的帝国公爵，为何总是出现在她的计划中？一段关于救赎与爱情的宫廷故事就此展开。',
    rating: 4.8,
    views: 1250000,
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: `ch1-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 30 - i)).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-03',
    tags: ['宫廷', '重生', '逆袭', '浪漫'],
    isHot: true,
    isNew: false,
  },
  {
    id: '2',
    title: '剑与魔法学院',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20webtoon%20cover%20featuring%20a%20young%20male%20mage%20with%20silver%20hair%20holding%20a%20glowing%20sword%20in%20a%20magical%20academy%20setting%2C%20fantasy%20elements%20floating%20around%2C%20action%20adventure%20genre%2C%20dramatic%20composition&width=400&height=560&seq=comic-02&orientation=portrait',
    category: '奇幻',
    categoryId: 'fantasy',
    author: '金泰亨',
    status: '连载中',
    description: '一个被魔法学院开除的废柴少年，意外觉醒了传说中的暗影之力。当古老的预言开始应验，他必须在光明与黑暗之间做出选择。魔法世界的终极大战即将拉开帷幕！',
    rating: 4.7,
    views: 980000,
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `ch2-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 28 - i)).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-02',
    tags: ['魔法', '学院', '冒险', '成长'],
    isHot: true,
    isNew: false,
  },
  {
    id: '3',
    title: '首尔暗影',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20Korean%20manhwa%20webtoon%20cover%20featuring%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20rainy%20Seoul%20streets%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20noir%20thriller%20style%2C%20mysterious%20atmosphere&width=400&height=560&seq=comic-03&orientation=portrait',
    category: '悬疑',
    categoryId: 'thriller',
    author: '朴志训',
    status: '已完结',
    description: '首尔繁华的霓虹灯下，隐藏着不为人知的黑暗。前刑警韩俊昊接手了一系列离奇案件，每个案件背后都指向一个庞大的犯罪组织。揭开真相的路上，他发现自己早已成为猎物的猎物。',
    rating: 4.9,
    views: 1560000,
    chapters: Array.from({ length: 60 }, (_, i) => ({
      id: `ch3-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2025-${String(Math.max(1, 12 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 25 - i)).padStart(2, '0')}`,
    })),
    updateDate: '2025-12-20',
    tags: ['悬疑', '犯罪', '都市', '推理'],
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    title: '甜蜜的陷阱',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20cover%20featuring%20a%20couple%20in%20a%20cozy%20cafe%20setting%2C%20cherry%20blossoms%20falling%2C%20warm%20pink%20and%20soft%20pastel%20color%20palette%2C%20sweet%20romance%20genre%2C%20soft%20lighting&width=400&height=560&seq=comic-04&orientation=portrait',
    category: '恋爱',
    categoryId: 'romance',
    author: '崔秀英',
    status: '连载中',
    description: '相亲对象竟然是公司里最讨厌的那个自大狂？本想直接拒绝，却被他的温柔一面所打动。一场始于谎言的相遇，能否开出真爱的花朵？甜到掉牙的都市浪漫喜剧！',
    rating: 4.6,
    views: 890000,
    chapters: Array.from({ length: 54 }, (_, i) => ({
      id: `ch4-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 24 - i)).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-01',
    tags: ['都市', '甜宠', '办公室', '契约恋爱'],
    isHot: false,
    isNew: true,
  },
  {
    id: '5',
    title: '猎魔人传说',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20cover%20featuring%20a%20fierce%20warrior%20with%20scarred%20face%20wielding%20twin%20blades%2C%20demonic%20creatures%20in%20the%20background%2C%20dark%20fantasy%20action%20genre%2C%20epic%20battle%20scene%2C%20dramatic%20lighting%20with%20red%20and%20black%20tones&width=400&height=560&seq=comic-05&orientation=portrait',
    category: '动作',
    categoryId: 'action',
    author: '姜东元',
    status: '连载中',
    description: '恶魔入侵人间，猎魔人是人类最后的希望。拥有最强血脉的少年姜浩，踏上了一条弑魔成神的不归路。每一次战斗都在挑战他的极限，而他背后隐藏的秘密比恶魔更加可怕。',
    rating: 4.5,
    views: 1120000,
    chapters: Array.from({ length: 68 }, (_, i) => ({
      id: `ch5-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 22 - i)).padStart(2, '0')}`,
    })),
    updateDate: '2026-07-30',
    tags: ['战斗', '热血', '恶魔', '超能力'],
    isHot: false,
    isNew: false,
  },
  {
    id: '6',
    title: '便利店老板的悠闲生活',
    cover: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20Korean%20manhwa%20cover%20featuring%20a%20friendly%20convenience%20store%20owner%20behind%20the%20counter%2C%20colorful%20snacks%20and%20drinks%20on%20shelves%2C%20slice%20of%20life%20genre%2C%20warm%20lighting%2C%20relaxing%20atmosphere&width=400&height=560&seq=comic-06&orientation=portrait',
    category: '日常',
    categoryId: 'daily',
    author: '尹智圣',
    status: '连载中',
    description: '辞去大公司的工作后，金社长接手了小区里的一家小便利店。原以为生活会变得平凡无趣，却在这里遇到了一群有趣的邻居。每个人都有自己的故事，而这家小小的便利店成为了他们生活的交集。',
    rating: 4.4,
    views: 670000,
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: `ch6-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 20 - i)).padStart(2, '0')}`,
    })),
    updateDate: '2026-07-28',
    tags: ['治愈', '日常', '美食', '温暖'],
    isHot: false,
    isNew: true,
  },
  {
    id: '7',
    title: '第九层地狱',
    cover: 'https://readdy.ai/api/search-image?query=A%20horror%20Korean%20manhwa%20cover%20featuring%20a%20dark%20staircase%20descending%20into%20an%20abyss%2C%20shadowy%20figures%20lurking%2C%20eerie%20atmosphere%2C%20psychological%20horror%20genre%2C%20dark%20red%20and%20black%20color%20scheme%2C%20ominous%20vibes&width=400&height=560&seq=comic-07&orientation=portrait',
    category: '惊悚',
    categoryId: 'horror',
    author: '文秀雅',
    status: '连载中',
    description: '一栋老旧公寓的电梯，按下B9层后会发生什么？七个互不相识的居民被困在了不存在于建筑蓝图上的第九层地狱。每过一小时，就有一个人会消失。惊悚到让人无法呼吸的悬疑恐怖之作！',
    rating: 4.3,
    views: 780000,
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: `ch7-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 19 - i)).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-03',
    tags: ['恐怖', '悬疑', '生存', '心理'],
    isHot: false,
    isNew: true,
  },
  {
    id: '8',
    title: '天才拳击手',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20sports%20cover%20featuring%20a%20muscular%20young%20boxer%20in%20the%20ring%2C%20sweat%20flying%2C%20action%20sports%20genre%2C%20intense%20expression%2C%20dramatic%20spotlight%20lighting%2C%20boxing%20gloves&width=400&height=560&seq=comic-08&orientation=portrait',
    category: '动作',
    categoryId: 'action',
    author: '郑基石',
    status: '连载中',
    description: '从街头混混到职业拳王，李天秀用拳头证明了自己的价值。但拳击台外的敌人比擂台上的对手更加危险。当黑帮势力试图操控比赛，他必须面对比拳击更加残酷的现实。',
    rating: 4.6,
    views: 840000,
    chapters: Array.from({ length: 56 }, (_, i) => ({
      id: `ch8-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 21 - i)).padStart(2, '0')}`,
    })),
    updateDate: '2026-07-31',
    tags: ['体育', '搏击', '热血', '成长'],
    isHot: false,
    isNew: false,
  },
  {
    id: '9',
    title: '魔王陛下想退休',
    cover: 'https://readdy.ai/api/search-image?query=A%20humorous%20Korean%20manhwa%20cover%20featuring%20a%20powerful%20demon%20lord%20in%20casual%20modern%20clothing%20trying%20to%20live%20a%20normal%20life%2C%20comedy%20fantasy%20genre%2C%20bright%20and%20colorful%2C%20funny%20expression&width=400&height=560&seq=comic-09&orientation=portrait',
    category: '喜剧',
    categoryId: 'comedy',
    author: '黄美英',
    status: '连载中',
    description: '统治魔界三千年的魔王大人突然宣布退休！他想体验普通人类的生活，却发现自己连去便利店买个饭团都会搞出幺蛾子。当千年魔王遇上现代都市，笑料百出的治愈喜剧！',
    rating: 4.7,
    views: 1020000,
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: `ch9-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 23 - i)).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-02',
    tags: ['搞笑', '奇幻', '反差萌', '日常'],
    isHot: true,
    isNew: false,
  },
  {
    id: '10',
    title: '蓝色大海的传说',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20fantasy%20cover%20featuring%20a%20mermaid%20with%20long%20flowing%20hair%20in%20the%20deep%20ocean%2C%20shimmering%20scales%2C%20sunlight%20filtering%20through%20water%2C%20fantasy%20romance%20genre%2C%20ethereal%20blue%20and%20golden%20tones&width=400&height=560&seq=comic-10&orientation=portrait',
    category: '奇幻',
    categoryId: 'fantasy',
    author: '张娜拉',
    status: '已完结',
    description: '深海中的美人鱼公主偶然救起了一位人类王子，从此命运的齿轮开始转动。为了追寻真爱，她不惜用声音交换一双人类的腿。一场跨越种族与海洋的绝世恋歌。',
    rating: 4.9,
    views: 1890000,
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: `ch10-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2025-${String(Math.max(1, 12 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 22 - i)).padStart(2, '0')}`,
    })),
    updateDate: '2025-12-15',
    tags: ['人鱼', '爱情', '奇幻', '经典'],
    isHot: true,
    isNew: false,
  },
  {
    id: '11',
    title: '重生之商道至尊',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20drama%20cover%20featuring%20a%20sharp-looking%20businessman%20in%20a%20luxury%20office%20with%20city%20skyline%20view%2C%20corporate%20drama%20genre%2C%20success%20story%2C%20modern%20setting%2C%20sophisticated%20atmosphere&width=400&height=560&seq=comic-11&orientation=portrait',
    category: '剧情',
    categoryId: 'drama',
    author: '林允儿',
    status: '连载中',
    description: '商业奇才陈明浩在功成名就之时意外重生回到二十年前。带着前世所有的商业记忆，他决定从零开始打造一个属于自己的商业帝国。商场如战场，步步惊心，精彩纷呈！',
    rating: 4.5,
    views: 760000,
    chapters: Array.from({ length: 58 }, (_, i) => ({
      id: `ch11-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 20 - i)).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-01',
    tags: ['重生', '商战', '职场', '逆袭'],
    isHot: false,
    isNew: false,
  },
  {
    id: '12',
    title: '我的邻居是吸血鬼',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20romantic%20Korean%20manhwa%20cover%20featuring%20a%20mysterious%20pale%20vampire%20man%20and%20a%20curious%20girl%20in%20a%20moonlit%20apartment%20setting%2C%20supernatural%20romance%20genre%2C%20gothic%20elements%2C%20moonlight%20through%20window&width=400&height=560&seq=comic-12&orientation=portrait',
    category: '恋爱',
    categoryId: 'romance',
    author: '郑秀晶',
    status: '连载中',
    description: '搬到新公寓的林小染发现隔壁住着一个只在夜晚出没的神秘男人。他冰冷的外表下藏着一颗孤独了数百年的心。当人类少女遇上吸血鬼邻居，一段跨越种族的禁忌之恋悄然展开。',
    rating: 4.6,
    views: 930000,
    chapters: Array.from({ length: 50 }, (_, i) => ({
      id: `ch12-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 4))).padStart(2, '0')}-${String(Math.max(1, 18 - i)).padStart(2, '0')}`,
    })),
    updateDate: '2026-07-29',
    tags: ['吸血鬼', '浪漫', '超自然', '都市'],
    isHot: false,
    isNew: true,
  },
];